import SessionEventProto from "../session-event-proto"
import {SESSION_PROJECT_USERS_CHANGED} from "../../gd/bus/bus-event-type"

export default class SessionProjectUsersResetByCompany extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        if (this.isDifferentCompany()) return false;

        gd.session.projectUsers.resetAndKeepOldModels(this.data)

        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
    }
}
